type ConsoleArgument = unknown | (() => unknown);

interface DebugInterface {
    trace: (...args: ConsoleArgument[]) => void;
    info: (...args: ConsoleArgument[]) => void;
    warn: (...args: ConsoleArgument[]) => void;
    error: (...args: ConsoleArgument[]) => void;
}

enum LogLevel {
    Trace = 'trace',
    Info = 'info',
    Warn = 'warn',
    Error = 'error',
}
// suche/angebot?airport[...]#C24_DEBUG
const hasDebugHash = window.location.hash.includes('C24_DEBUG');
if (hasDebugHash) {
    window.sessionStorage.setItem(
        'C24_DEBUG',
        JSON.stringify([
            LogLevel.Trace,
            LogLevel.Info,
            LogLevel.Warn,
            LogLevel.Error,
        ])
    );
}

const sessionLogLevel = JSON.parse(
    (window.sessionStorage && window.sessionStorage.getItem('C24_DEBUG')) ||
        '[]'
);
export const logLevels: Set<LogLevel> = Array.isArray(sessionLogLevel)
    ? new Set(sessionLogLevel)
    : new Set();

function executeSupplier(args: ConsoleArgument[]): unknown[] {
    return args.map((argument) =>
        typeof argument === 'function' && argument.length === 0
            ? argument()
            : argument
    );
}

const Console: DebugInterface = {
    trace: logLevels.has(LogLevel.Trace)
        ? (...args) => {
              // eslint-disable-next-line no-console
              console.trace(...executeSupplier(args));
          }
        : () => {},
    info: logLevels.has(LogLevel.Info)
        ? (...args) => {
              // eslint-disable-next-line no-console
              console.info(...executeSupplier(args));
          }
        : () => {},
    warn: logLevels.has(LogLevel.Warn)
        ? (...args) => {
              // eslint-disable-next-line no-console
              console.warn(...executeSupplier(args));
          }
        : () => {},
    error: logLevels.has(LogLevel.Error)
        ? (...args) => {
              // eslint-disable-next-line no-console
              console.error(...executeSupplier(args));
          }
        : () => {},
};

export default Console;
